import {
  createSlice,
  SerializedError,
  PayloadAction
} from '@reduxjs/toolkit'
import { FetchBaseQueryError } from '@reduxjs/toolkit/query'
import { RootState } from '../../app/store'
import uuidv4 from '../../utils/uuidv4'

export type Session = {
  expireTime: number | null
  kioskId: string
  token: string
  username: string
  accessCode: string
}
export type SessionState = Session
export type SessionError = { error: FetchBaseQueryError | SerializedError }
export type SessionResponse = SessionError | Session

const initialState: SessionState = {
  expireTime: null,
  kioskId: uuidv4(),
  token: '',
  username: '',
  accessCode: '',
}

export const sessionSlice = createSlice({
  name: 'session',
  initialState,
  reducers: {
    cacheToken: (state, action: PayloadAction<string>) => {
      state.token = action.payload
      state.expireTime = new Date().getTime() + 12 * 60 * 60 * 1000 // 12 hours
    },
    setUsername: (state, action: PayloadAction<string>) => {
      state.username = action.payload || ''
    },
    setAccessCode: (state, action: PayloadAction<string>) => {
      state.accessCode = action.payload
    },
    clearSession: (state) => {
      state.token = ''
      state.username = ''
      state.accessCode = ''
    },
  }
})

export const {
  cacheToken,
  setUsername,
  setAccessCode,
  clearSession,
} = sessionSlice.actions

export const getKioskIdSelector = (state: RootState): string => state.session?.kioskId
export const getTokenSelector = (state: RootState): string => {
  if (state.session?.expireTime! < new Date().getTime()) {
    return ''
  }
  return state.session?.token
}
export const getUsernameSelector = (state: RootState): string => state.session?.username

export const getAccessCodeSelector = (state: RootState): string => state.session?.accessCode

export default sessionSlice.reducer
